<template>
  <div class="home">
    <van-swipe
    :autoplay="3000"
    indicator-color="white"
    >
    <van-swipe-item
    v-for="item in sliders" :key="'swipe_'+item.id"
    >
    <a :href="'https://m.motortime.com/article/'+item.id+'/post'">
     <!-- @click="picurl" -->
     <img class="swipe-img" v-lazy="item.m_pic_url" :id="item.id" :name="item.module.id">
   </a>
 </van-swipe-item>
</van-swipe>
<van-list
v-model="loading"
:finished="finished"
finished-text="没有更多了"
@load="onLoad"
>
<div slot="loading" class="list-loading">
  <img :src="this.img.loading" />
  <span>正在刷新</span>
</div>
<div class="list-box" v-for="(item, index) in list" :key="'list_' + item.id">
  <div v-if="item.module.id==1">
    <div v-if="item.topic_info.id">
      <div class="topic-box" :style="'background-image:url('+item.topic_info.pic_url+')'" @click="topicShow(item.topic_info.id)">
        <div class="picount">
          <div class="f-16 mt-10 f-w">#{{item.topic_info.name}}#</div>
        </div>
      </div>
    </div>
    <div v-else>
      <!-- <router-link :to="{name: 'ContentPostShow', params: {id: item.id}}"> -->
        <a :href="'https://m.motortime.com/article/'+item.id+'/post'">
          <van-row gutter="15">
            <van-col span="8">
              <img class="picone" v-lazy="item.pic_url">
            </van-col>
            <van-col class="listitle" span="16">
              {{ item.title }}
              <van-tag plain type="danger" v-if="item.label!=null">{{item.label.name}}</van-tag>
            </van-col>
          </van-row>
        </a>
        <!-- </router-link> -->
        <van-row type="flex" justify="space-between">
          <van-col span="16">
            <span class="sourtime"><i v-if="item.media!=null">{{item.media.name}}</i>{{item.time_format}}</span>
          </van-col>
          <van-col class="bintright" span="8">
            <span>
              <img class="binpic" :src="img.comment">
              <span class="sourtime">{{item.reply_num}}</span>
            </span>
            <span class="binbox">
              <img @click="setPraise(index)" class="binpic" :src="item.is_praise ? img.parise_have : img.parise">
              <span class="sourtime">{{item.praise}}</span>
            </span>
          </van-col>
        </van-row>
      </div>
    </div>
    <div v-if="item.module.id==2">
      <div v-if="item.topic_info.id">
        <div class="topic-box" :style="'background-image:url('+item.topic_info.pic_url+')'" @click="topicShow(item.topic_info.id)">
          <div class="picount">
            <div class="f-16 mt-10 f-w">#{{item.topic_info.name}}#</div>
          </div>
        </div>
      </div>
      <div v-else>
        <div class="listitle">
          <!-- <router-link :to="{name: 'ContentPostShow', params: {id: item.id}}"> -->
            <a :href="'https://m.motortime.com/article/'+item.id+'/post'">
              {{ item.title }}
              <van-tag plain type="danger" v-if="item.label!=null">{{item.label.name}}</van-tag>
            </a>
            <!-- </router-link> -->
          </div>
          <div class="pic">
            <!-- <router-link :to="{name: 'ContentPostShow', params: {id: item.id}}"> -->
              <a :href="'https://m.motortime.com/article/'+item.id+'/post'">
                <van-row gutter="5">
                  <van-col span="16">
                    <img v-if="item.pics && item.pics[0]" v-lazy="item.pics[0].img_url" :alt="item.title" />
                  </van-col>
                  <van-col span="8">
                    <img v-if="item.pics && item.pics[1]" v-lazy="item.pics[1].img_url" :alt="item.title" class="right one" />
                    <img v-if="item.pics && item.pics[2]" v-lazy="item.pics[2].img_url" :alt="item.title" class="right" />
                  </van-col>
                </van-row>
              </a>
              <!-- </router-link> -->
            </div>
            <van-row type="flex" justify="space-between">
              <van-col span="16">
                <span class="sourtime"><i v-if="item.media!=null">{{item.media.name}}</i>{{item.time_format}}</span>
              </van-col>
              <van-col class="bintright" span="8">
                <span class="">
                  <img class="binpic" :src="img.comment">
                  <span class="sourtime">{{item.reply_num}}</span>
                </span>
                <span class="binbox">
                  <img @click="setPraise(index)" class="binpic" :src="item.is_praise ? img.parise_have : img.parise">
                  <span class="sourtime">{{item.praise}}</span>
                </span>
              </van-col>
            </van-row>
          </div>
        </div>
        <div v-if="item.module.id==4">
          <div v-if="item.topic_info.id">
            <div class="topic-box" :style="'background-image:url('+item.topic_info.pic_url+')'" @click="topicShow(item.topic_info.id)">
              <div class="picount">
                <div class="f-16 mt-10 f-w">#{{item.topic_info.name}}#</div>
              </div>
            </div>
          </div>
          <div v-else>
            <van-row type="flex" justify="space-between" v-if="item.user">
              <van-col span="4">
                <img class="listhand" :src="item.user.headimg_url ? item.user.headimg_url : img.avatar">
              </van-col>
              <van-col span="16">
                <div class="membername f-15">
                  {{item.user.user_name}}
                </div>
                <div class="sourtime">
                  {{item.time_format}}  浏览 {{item.show_num}}
                </div>
              </van-col>
              <van-col class="bintright" span="4">
              </van-col>
            </van-row>
            <div class="listitle ellipsis-2" @click="BbsShow(item.id,item.url)">{{item.title}}</div>
            <div class="f-14 ellipsis-2" @click="BbsShow(item.id,item.url)"><span class="c-blue" v-if="item.tags.length>0">#{{item.tags[0].name}}#</span>
              {{item.content}}
            </div>
            <div class="text-r c-blue f-14" @click="BbsShow(item.id,item.url)">
             查看全部
           </div>
           <div class="pic-box" v-if="item.cover&&item.image.length==0" @click="BbsShow(item.id,item.url)">
            <img class="pic_thumb" v-lazy="item.cover||item.image[0]">
          </div>
          <div class="pic-box" v-if="item.image.length==1" @click="BbsShow(item.id,item.url)">
            <img class="pic_thumb" v-lazy="item.cover||item.image[0]">
          </div>
          <div class="pic-box" v-if="item.image.length>1">
            <img class="pic_thumb" v-lazy="item.cover||item.image[0]" @click="showPic(index)">
            <div class="piclength">{{item.cover?item.image.length+1:item.image.length}}P</div>
          </div>
          <van-row type="flex" justify="space-between">
            <van-col span="14">
              <van-tag color="#F6AB00" round>{{item.channel.alias}}</van-tag>
            </van-col>
            <van-col class="bintright" span="10">
              <span class="">
                <img class="binpic" :src="img.comment">
                <span class="sourtime">{{item.comment_num}}</span>
              </span>
              <span class="binbox">
                <img class="binpic" @click="setPraise(index)" :src="item.is_praise ? img.parise_have : img.parise">
                <span class="sourtime">{{item.praise_num}}</span>
              </span>
            </van-col>
          </van-row>
        </div>
      </div>
    </div>
  </van-list>
</div> 
</template>
<script>
  import content from '../../api/content';
  import wxShare from '../../api/wxShare';
  import { mapState } from 'vuex';
  import { Swipe, SwipeItem, List, Row, Col, Tag,Popup,ImagePreview  } from "vant";
  import Search from './Common/Search';

  export default {
    data () {
      return {
        params: {
          page: 1,
          user_id: 0,
          source:''
        },
        list: [],
        loading: false,
        finished: false,
        sliders: [],
        img: {
          parise: require('../../assets/img/parise.png'),
          parise_have: require('../../assets/img/parise_have.png'),
          comment: require('../../assets/img/comment.png'),
          loading: require('../../assets/img/loading.gif'),
          motortime_logo:require('../../assets/img/motortimelogo.png'),
          wechateq:require('../../assets/img/wechateq.png')
        }
      }
      
    },
    computed: {
      ...mapState({
        user: state => state.param.user,
        source: state => state.param.source
      })
    },
    created () {
      this.getSlider()
      this.getList()

      content.getShare({url:encodeURI(location.href)}).then(res => {
        if(res.data.state == 1) {
         wxShare.getJSSDK(res.data.data, {
          'title': '汽车时间_属于你的汽车时间_motortime.com',
          'description':'汽车时间，提供汽车行业有特色的新闻资讯、汽车图片、要闻推送；同时，还有线下车友活动组织、线上汽车商品促销信息，满足您对汽车资讯需要。',
          'pic_url':'https://pic.motortime.com/static/motortime_uni/logo.png'
        })
       }
     })
    },
    activated () {
      if(this.source == 1) {
        this.$store.commit('param/show', true)
        this.$store.commit('param/active', 'Home')
      } else {
        this.$store.commit('param/show', false)
        this.$appService.isShowReturn({state: false})
      }
    },
    methods: {
      getList(){
        this.params.user_id = this.user ? this.user.id : 0
        this.params.source = this.source
        content.getIndexList(this.params).then(res => {
          this.list.push.apply(this.list, res.data.data)
          this.loading = false
          if(res.data.data.length == 0) {
            this.finished = true
          }
        })
      },
      setPraise (index) {
        // this.$store.commit('param/eqshow', true)
        if(this.source == 3||this.source == 7) {
          this.$appService.getToken(v => {
            if(v.token) {
              this.$store.dispatch('param/setToken', v.token)
              let type = this.list[index].is_praise ? 2 : 1;
              content.setPraise({id: this.list[index].id, type: type}).then(res => {
                if(res.data.state == 1) {
                  if(type == 1) {
                    this.list[index].is_praise = 1
                    this.list[index].praise += 1
                    this.$toast.success('点赞成功')
                  } else {
                    this.list[index].is_praise = 0
                    this.list[index].praise -= 1
                    this.$toast.success('取消成功')
                  }
                }
              })
            } else {
              this.$appService.needLogin()
            }
          })
        }else if(this.source == 1){
          if(localStorage.getItem('token')){
            this.token=true
            let type = this.list[index].is_praise ? 2 : 1;
            content.setPraise({id: this.list[index].id, type: type}).then(res => {
              if(res.data.state == 1) {
                if(type == 1) {
                  this.list[index].is_praise = 1
                  this.list[index].praise += 1
                  this.$toast.success('点赞成功')
                } else {
                  this.list[index].is_praise = 0
                  this.list[index].praise -= 1
                  this.$toast.success('取消成功')
                }
              }
            })
          }else{
            this.getAuthorization.getAuthorization();
          }
        }
        
      },
      getSlider () {
        content.getSliders({}).then(res => {
          if(res.data.state == 1) {
            this.sliders = res.data.data
          }
        })
      },
      picurl(e){
        let id=e.target.id
        let ptype=e.target.name
        this.$router.push({name:'ContentPostShow',params:{id:id}});
      },
      BbsShow(id,url){
        this.$router.push({name:'BbsShow',params:{id:id}});
      },
      showPic(index){
        var list=this.list
        var imagelist = []
        var image = list[index].image
        for (var i = 0; i < image.length; i++) {
          imagelist.push(image[i])
        }
        if (list[index].cover) {
          var cover = list[index].cover
          imagelist.unshift(cover)
        }
        ImagePreview({
          images: imagelist,
          startPosition: 0,
        });
      },
      topicShow(id){
        this.$router.push({name:'TopicInfo',params:{id:id}});
      },
      onLoad() {
        this.params.user_id = this.user ? this.user.id : 0
        this.params.source = this.source
        // 异步更新数据
        if(this.params.page>0){
          setTimeout(() => {
            this.params.page += 1
            content.getIndexList(this.params).then(res => {
              this.list.push.apply(this.list, res.data.data)
              this.loading = false
              if(res.data.data.length == 0) {
                this.finished = true
              }
            })
          }, 500);
        }
        
      }
    },
    components: {
      [Swipe.name]: Swipe,
      [SwipeItem.name]: SwipeItem,
      [Row.name]: Row,
      [Col.name]: Col,
      [List.name]: List,
      [Tag.name]: Tag,
      [Popup.name]:Popup,
      [ImagePreview .name]:ImagePreview 
      // Search
    }
  }
</script> 

<style lang="scss">
  .home{
    padding-bottom: 60px;

    .swipe-img{
      width: 100%;
      height: 225px;
      display: block;
      object-fit: cover;
    }
    .list-box{
      padding: 10px 10px;
      border-bottom: 1px solid #EAEAEA;
      .listhand{
        width:45px;
        height:45px;
        border-radius:30px;
      }
      .membername{
        font-size: 15px;
        font-weight: bold;
      }
      a {
        padding: 0;
        color: #3A3A3A;
      }
      .picone{
        width:116px;
        height:96px;
        border-radius: 3px;
        display: block;
        object-fit: cover;
      }

      .listitle{
        font-size: 16px;
        font-weight:bold;
        line-height: 25px;

        .van-tag {
          font-weight: normal;
        }
      }
      .sourtime{
        font-size: 12px;
        color: #9A9A9A;

        i {
          font-style: normal;
          padding-right: 10px;
        }
      }
      .binpic{
        width:15px;
        height:14px;
        margin-right: 10px;
        // vertical-align: middle;
      }
      .bintright{
        text-align: right;
      }
      .binbox{
        margin-left:28px;
      }
      .pic {
        margin-top: 5px;
        img {
          width: 100%;
          height: 205px;
          object-fit: cover;
          display: block;
          border-radius: 3px;

          &.right {
            height: 100px;
          }
          &.one {
            margin-bottom: 5px;
          }
        }
      }
      .pic-box {
        padding: 10px 0;
        .pic_thumb {
          border-radius: 5px;
          width: 100%;
          height: 225px;
          object-fit: cover;
          display: block;
        }
      }
      .topic-box {
        width: 100%;
        height: 225px;
        border-radius: 5px;
        object-fit: cover;
        background-size:cover;
        background-position:center;
        display: flex;
        -webkit-box-align: center;
        -webkit-align-items: center;
        align-items: center;
        text-align: center;
        justify-content: center;
        .picount{
          color: #fff;
          padding: 10px;
        }
      }
      .nine-pic {
        width: 100%;
        height: 100px;
        border-radius: 3px;
        object-fit: cover;
        display: block;
      }
      .van-grid-item__content{
        padding: 2.5px;
      }
    }
    .piclength{
      width: 30px;
      float: right;
      margin-right: 10px;
      margin-top: -25px;
      position: relative;
      font-size: 10px;
      color: #fff;
      background-color: #000000;
      opacity: 0.5;
      text-align: center;
    }
  }
</style>
